export default __webpack_public_path__ + "static/media/9ChevroletCruze.8165ca58.jpg";